import { useQuery } from '@tanstack/react-query'
import { getSessionIdFromLocalStorage } from 'src/localStorage/sessionId/getSessionIdFromLocalStorage/getSessionIdFromLocalStorage'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { CustomReportsApiService } from 'src/services/customReportsApi'

// Generation runs in the background with no push channel, so the list polls
// while anything is still rendering and stops once everything has settled.
const POLL_INTERVAL_MS = 5000

export const useGetCustomReportsQuery = () => {
  const sessionId = getSessionIdFromLocalStorage()

  return useQuery({
    enabled: !!sessionId,
    queryFn: () => CustomReportsApiService.getList(),
    queryKey: [QueryKey.GET_CUSTOM_REPORTS],
    refetchInterval: ({ state }) => {
      const isGenerating = state.data?.data?.some(
        (report) => report.status === 'generating'
      )

      return isGenerating ? POLL_INTERVAL_MS : false
    },
  })
}
